import Vue from 'vue';
import helpers from './mixins/helpers'
if (document.getElementById('settings-account')) {
    $(document).ready(function () {
        let formNode = $('#settings-form');
        $("#settings-form-current_password").keydown(function () {
            $('#settings-form').yiiActiveForm('updateAttribute', 'settings-form-current_password', '');
        });
        $("#settings-form-new_password").keydown(function () {
            $('#settings-form').yiiActiveForm('updateAttribute', 'settings-form-new_password', '');
        });
        let countries = {
            1: {name: 'Россия', mask: "7 (999) 999-99-99", placeholder: "+7 (999) 999-99-99"},
            2: {name: 'Украина', mask: "380 99 999 9999", placeholder: "+380 99 999 9999"},
            3: {name: 'Беларусь', mask: "375 99 999-99-99", placeholder: "+375 99 999-99-99"},
            4: {name: 'Казахстан', mask: "7 (999) 999 9999", placeholder: "+7 (999) 999 9999"},
            5: {name: 'Азербайджан', mask: "\\9\\94 (99) 999 99 99", placeholder: "+994 (99) 999 99 99"},
            6: {name: 'Армения', mask: "374 99 999 999", placeholder: "+374 99 999 999"},
            7: {name: 'Грузия', mask: "\\9\\95 999 99 99 99", placeholder: "+995 999 99 99 99"},
            8: {name: 'Израиль', mask: "\\972 99 999 99 99", placeholder: "+972 99 999 99 99"},
            9: {name: 'США', mask: "1 (999) 999-9999", placeholder: "+1 (999) 999-9999"}
        };

        if (typeof countries[country] !== 'undefined') {
            $("#settings-form-phone").inputmask({"mask": countries[country].mask, clearMaskOnLostFocus: true});
            $("#settings-form-phone").attr("placeholder", countries[country].placeholder);
        } else {
            $("#settings-form-phone").inputmask('remove');
        }

        formNode.on('ajaxComplete', function (event, jqXHR, textStatus) {
            let data = jqXHR.responseJSON;
            if (registration.phone.number.replace(/[^0-9]+/g, '').length >= 10) {

                registration.phone.phoneValid = !data.hasOwnProperty('settings-form-phone');

            }
            registration.phone.confirmNumber = !data.hasOwnProperty('settings-form-confirm_sms_code') && registration.phone.sendCode;
        });

    });
    Vue.directive('select2', {
        bind: function (el, binding, node) {
            $(el)
                .on("select2:select", function (e) {
                    registration[binding.expression] = $(this).val()
                })
                .on("select2:unselect", function (e) {
                    registration[binding.expression] = ''
                });
        }
    });
    let registration = new Vue({
        mixins: [helpers],
        el: "#settings-account",
        data: {
            phone: {
                number: phone,
                changePhone: false,
                sendCode: false,
                confirmNumber: false,
                phoneValid: false,
                verifyCode: null,
                codeErrorMessage: null,
                phoneVerified: phone ? true : false,
                phoneExist: phone ? true : false,
                resendCountDown: {
                    interval: null,
                    seconds: null,
                    message: 'Отправить код повторно можно будет через 2 минуты'
                }
            },
            country: country,
            errors: false,
            number: ''
        },
        methods: {
            phoneValidate(phone) {
                this.phone.number = phone;
                if (registration.phone.number.replace(/[^0-9]+/g, '').length >= 11) {
                    $('#settings-form').yiiActiveForm('validateAttribute', 'settings-form-phone');
                }
            },
            codeValidate(code) {

                this.phone.verifyCode = code;

                if (registration.phone.verifyCode.length >= 4) {

                    $('#settings-form').yiiActiveForm('validateAttribute', 'settings-form-confirm_sms_code');

                }
            },
            changeNumber() {
                this.phone.sendCode = false;
                this.phone.phoneValid = false;
                this.phone.verifyCode = null;
                this.phone.phoneVerified = false;
                this.phone.changePhone = true;

            },
            sendCode() {
                let self = this;
                this.phone.resendCountDown.seconds = 120;
                this.phone.sendCode = true;

                clearInterval(this.phone.resendCountDown.interval);

                this.phone.resendCountDown.interval = setInterval(function () {
                    self.resendCountDown()
                }, 1000);

                try {

                    $.ajax({
                        url: '/user/registration/send-confirm-code',
                        dataType: "json",
                        method: 'POST',
                        data: {
                            phone: self.phone.number,
                            _csrf: self.getCsrf()
                        },
                        success: function (data) {
                            console.log(data)
                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);


                }

            },
            resendCountDown() {
                let self = this;
                if (this.phone.resendCountDown.seconds === 0) {

                    clearInterval(this.phone.resendCountDown.interval);

                    this.phone.resendCountDown.message = 'Отправить код повторно можно будет через 2 минуты';

                } else {

                    this.phone.resendCountDown.seconds--;
                    let time = new Date(this.phone.resendCountDown.seconds * 1000);
                    let message = 'Отправить код повторно можно будет через ';

                    if (time.getMinutes() > 0) {
                        let minute = time.getMinutes();
                        message += minute + ' ' + self.decOfNum(minute, ['минуту', 'минуты', 'минут']) + ' ';
                    }
                    let seconds = time.getSeconds();
                    message += seconds + ' ' + self.decOfNum(seconds, ['секунда', 'секунды', 'секунд']);
                    this.phone.resendCountDown.message = message;

                }
            }
        },
        created() {},
        computed: {}
    });
}